import React, { useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import "./atsPipeline.css";
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { AppContext } from '../ContextApi/ContextApi';
import { basePath, isObject, monthData, validateFile, validatePhoneNumber, validateNumber, isValidDateTillCurrent, candidateStatusList, positionStatusOptions, atsStatus1, atsStatus2, atsStatus3, atsStatus4, atsStatus5, formatDate } from '../Constants/constant';
import { useLocation, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import EditCandidate from '../Usables/EditCandidate';
import Pagination from '../Usables/Pagination';
import RefreshButton from '../Usables/RefreshButton';
import NoRecords from '../Usables/NoRecords';
import Loader from '../Usables/Loader';
import PageBanner from '../Usables/PageBanner';
import CandidateStatusHistory from '../Usables/CandidateStatusHistory';
import InterviewScheduleModal from '../Usables/interviewScheduleModal';
import InputField from '../Usables/InputField';
import Dropdown from '../Usables/Dropdown';
import BasicButton, { EmailSendButton, HistoryButton, RevertStatusButton } from '../Usables/Buttons';
import PositionWiseData from '../Usables/PositionWiseData';
import { UpDownArrow } from '../Usables/IconButtons';
import CompanyInfo from '../Usables/CompnayInfo';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function AtsPipeline(props) {
    const { index } = useParams();
    const query = useQuery();
    const fromDateAts = query.get("fromDate");
    const toDateAts = query.get("toDate");
    const statusAts = query.get("status");
    const positionName = query.get("position");
    const companyName = query.get("company");
    const candidateStatus = query.get("candidateStatus");
    const { apiHeaderFile, setIsModalOpen, apiHeaderJSON, user } = useContext(AppContext);
    const [allUsers, setAllUsers] = useState([]);
    const [usersOption, setUsersOption] = useState([]);
    const [atsPipeline, setAtsPipeline] = useState([]);
    const [status, setStatus] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [loadingUpdate, setLoadingUpdate] = useState(false);
    const [candidateEdit, setCandidateEdit] = useState(false);
    const [positionWiseView, setPositionWiseView] = useState(false);
    const [positionWiseData, setPositionWiseData] = useState([]);
    const [viewCandidate, setViewCandidate] = useState(false);
    const [viewCompany, setViewCompany] = useState(false);
    const [viewCandidateHistory, setViewCandidateHistory] = useState(false);
    const [pagination, setPagination] = useState({page: 1, totalRecords: "", totalPages: "", limit: 10,});
    const [paginationPositionList, setPaginationPositionList] = useState({page: 1, totalRecords: "", totalPages: "", limit: 10,});
    const [ischanged, setIschanged] = useState({positionListChanged: false, getListChanged: false, revertStatus: false});
    const [formData, setFormData] = useState({});
    const [isStatusChanged, setIsStatusChanged] = useState(false);
    const [filterData, setFilterData] = useState({
        fromDate: fromDateAts ? fromDateAts : '',
        toDate: toDateAts ? toDateAts : "",
        status: statusAts ? statusAts : candidateStatus ? candidateStatus : "",
        position: positionName || "",
        company: companyName || "",
        isActive: true,
        positionStatus: positionName  || statusAts || candidateStatus ? "All" : "Open",
        orderBy: "sent_to_client_date",
        orderDirection: "DESC"
    });
    const [positionFilter, setPositionFilter] = useState({orderBy: "upload_date", orderDirection: "DESC", isActive: true,});
    const [interviewModal, setInterviewModal] = useState(false);
    const [candidateId, setCandidateId] = useState("");

    const getList = useCallback(async()=> {
        try {
            const options = {
                params: {
                    limit:pagination?.limit,
                    page:pagination?.page,
                    filter:JSON.stringify(filterData),
                },
                headers: apiHeaderJSON
            }
            const res = await axios.get(`${basePath}/getatspipelinebypage`, options);
            console.log(res.data);
            setAtsPipeline(res.data?.Candidates);
            setPagination({
                ...pagination,
                totalPages: res.data?.pages,
                totalRecords: res.data?.totalRecords
            });
            if (statusAts || positionName || companyName) {
                const url = new URL(window.location.href);
                url.searchParams.delete("status");
                url.searchParams.delete("position");
                url.searchParams.delete("company");
                url.searchParams.delete("fromDate"); 
                url.searchParams.delete("toDate"); 
                window.history.replaceState({}, document.title, url.pathname + url.search);
            }
            setLoading(false);
            setLoadingFilter(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
            setLoadingFilter(false);
        }
        // setRowData(sent);
    },[filterData, pagination]);

    const getUserData = async () => {
        try {
            const options = {headers: apiHeaderJSON}
            const response = await axios.get(`${basePath}/getRecruiter`, options);
            // console.log(response.data);
            const recruiterList = response?.data?.map((val)=>{
                return {value: val?.id, label: val?.name, activated: val?.activated}
            });
            const listFilter = response?.data?.filter((val)=>{
                if(val?.activated === 1) return  val;
            });
            const activeList = listFilter?.map((val)=>{
                return {value: val?.id, label: val?.name, activated: val?.activated}
            });
            setAllUsers(recruiterList);
            setUsersOption(activeList);
        } catch (error) {
            toast.error("There is some server issue!!")
        }
    }

    useEffect(() => {
        setLoading("1");
        getList();
        getUserData();
    }, []);

    useEffect(() => {
        if(ischanged?.getListChanged){
            // console.log("in getList");
            getList();
            setIschanged({ ...ischanged, getListChanged: false });
        }
    }, [ischanged?.getListChanged]);

    useEffect(() => {
        if(ischanged?.positionListChanged){
            // console.log("in getPositionWiseData");
            getPositionWiseData();
            setIschanged({ ...ischanged, positionListChanged: false })
        }
    }, [ischanged?.positionListChanged]);

    const handleAtsSort = (columnName) => {
        if (filterData?.orderBy === columnName) {
            if (filterData?.orderDirection === "DESC") {
                setFilterData({ ...filterData, orderBy: columnName, orderDirection: 'ASC' });
            }
            else {
                setFilterData({ ...filterData, orderBy: columnName, orderDirection: 'DESC' });
            }
        }
        else {
            setFilterData({ ...filterData, orderBy: columnName, orderDirection: 'ASC' });
        }
        setIschanged({ ...ischanged, getListChanged: true });
    }

    const getPositionWiseData = useCallback(async()=> {
        try {
            const res = await axios.get(`${basePath}/getpositionwisecandidatecount`,{
                limit:paginationPositionList?.limit,
                page:paginationPositionList?.page, 
                id:localStorage.getItem("userId"),
                filter:JSON.stringify(positionFilter),
                headers:apiHeaderJSON
            });
            const temp = res.data?.report?.filter((val) => {if (val?.candidate_count) {return val;}});
            // console.log("+++++>>>>>getPositionWiseData ~ temp", temp);
            setPositionWiseData(temp);
            // let pages = temp?.length / 10;
            // pages = Math.ceil(pages);
            setPaginationPositionList({
                ...paginationPositionList,
                totalPages: res?.data?.pages,
                totalRecords: res?.data?.totalRecords
            });
            setLoading(false);
            setLoadingFilter(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
            setLoadingFilter(false);
        }
        // setRowData(sent);
    },[paginationPositionList, positionFilter]);

    const handleExport = async () => {
        try {
            setLoadingFilter("3");
            const response = await axios.get(`${basePath}/getatspipelinebypage`, {
                responseType: 'blob', // Ensure response is treated as a blob
                headers:apiHeaderJSON,
                params:{
                    download:"yes",
                    filter:JSON.stringify(filterData),
                    page:pagination.page,
                    limit:pagination.limit
                }
            });

            // Create a URL for the blob object
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a temporary <a> element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'ATS_Pipeline.xlsx');
            document.body.appendChild(link);
            link.click();

            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            setLoadingFilter(false);
        } catch (error) {
            // console.error('Error exporting jobs:', error);
            setLoadingFilter(false);
        }
    };

    // fetching candidate history
    async function getCandidateHistory(e) {
        const {value} = e.target;
        setLoading("2");
        try {
            let res = await axios.get(`${basePath}/statushistory/${value?.id}`);
            // console.log(res.data);
            setViewCandidateHistory(res.data.history);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
        // setRowData(sent);
    }

    const handleSort = (e) => {
        const {id} = e.currentTarget;
        // console.log("id", id);
        if (positionFilter?.orderBy === id) {
            if (positionFilter?.orderDirection === "DESC") {
                setPositionFilter({ ...positionFilter, orderBy: id, orderDirection: 'ASC' });
            }
            else {
                setPositionFilter({ ...positionFilter, orderBy: id, orderDirection: 'DESC' });
            }
        }
        else {
            setPositionFilter({ ...positionFilter, orderBy: id, orderDirection: 'ASC' });
        }
        setIschanged({ ...ischanged, positionListChanged: true });
    }

    const handlePositionSelect = (e)=> {
        const { value } = e.target;
        setFilterData({
            ...filterData,
            company: value?.company_name,
            position: value?.position_name,
            fromDate: "",
            toDate: "",
            candidate: "",
            orderBy: "sourcing_date",
            orderDirection: "DESC"
        });
        setPositionWiseView(false);
        setIschanged({ ...ischanged, getListChanged: true });
    }

    const handleRevertStatus = async (val) => {
        Swal.fire({
        title: 'Are you sure?',
        text: 'You want to revert status!',
        icon: 'warning',
        input: 'textarea',
        inputLabel: 'Reason (required)',
        inputPlaceholder: 'Enter reason for revert...',
        inputAttributes: {'aria-label': 'Enter Reason',},
        showCancelButton: true,
        confirmButtonText: 'Yes, Revert!',
        cancelButtonText: 'No, Cancel!',
        confirmButtonColor: '#1F1E30',
        cancelButtonColor: '#F44336',
        allowOutsideClick: false,
        preConfirm: (remark) => {
            if (!remark || remark.trim() === '') {
            Swal.showValidationMessage('Reason is required');
            return false;
            }
            return remark;
        }}).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Please wait...',
                    html: 'Sending Email...',
                    allowOutsideClick: false,
                    didOpen: () => {Swal.showLoading();}
                });
                const data = {remarks: result.value, candidate_id: val?.id}
                // console.log(candidateId);
                const options = {
                    url: `${basePath}/RevertCandidateStatus`,
                    method: "POST",
                    headers: apiHeaderJSON,
                    data,
                }
                axios(options).then((response) => {
                    if (response.status === 200) {
                        setLoading(false);
                        // console.log(response);
                        getList();
                        toast.success(response?.data?.message || "Candidate Status Updated Successfully");
                    }
                    else {
                        toast.error(response?.data?.message || "Unable to Update");
                    }
                    Swal.close();
                })
                .catch((e) => {
                    Swal.close();
                    console.log(e);
                    toast.error(e.response?.data?.message || "There is some network error!! Please try again later.");
                });
            }})
    }

    async function checkCandidateExist(candidateId) {
        try {
            // console.log("candidateId====>>>", candidateId);
            let res = await axios.get(`${basePath}/existedcandidate?id=${candidateId}`);
            // console.log("=========>>>>>>>>>>", res);
            if (res?.status === 200) {
                setInterviewModal("Interview Scheduled");
                setFormData({});
            }
        } catch (error) {
            console.log(error);
            if (error?.response?.status === 404) {
                toast.error(error?.response?.data?.error);
            } else {
                toast.error("There is some network error!! Please try again later.");
            }

        }
        // setRowData(sent);
    }

    const handleSendEmail = async (e) => {

        Swal.fire({
            title: 'Are you sure?',
            text: `You want to send email!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Send!',
            cancelButtonText: 'No, Cancel!',
            confirmButtonColor: '#1F1E30', 
            cancelButtonColor: '#F44336',
            allowOutsideClick:false,
        }).then((result) => {
            if (result.isConfirmed) {
                const {value} = e.target;
                Swal.fire({
                    title: 'Please wait...',
                    html: 'Sending Email...',
                    allowOutsideClick: false,
                    didOpen: () => {Swal.showLoading();}
                });
                const formData = {
                    candidate_id: value?.id,
                    status: value?.candidate_status
                }
                axios.post(`${basePath}/sendMailOnStatusChange`, formData, {
                    headers: {
                       ...apiHeaderJSON,
                    },
                })
                .then((response)=>{
                    if (response.status === 200) {
                        setCandidateId('');
                        toast.success( response.message || "Email Sent Successfully");
                    }
                    else{
                        toast.error( response.error || "Unable to send email!");
                    }
                    Swal.close();
                })
                .catch((error)=>{
                    Swal.close();
                    console.log('sendMailOnStatusChange ===========>>>>>>>>>>>>>',error);
                    toast.error( error?.response?.data?.error ||  "Unable to Send");
                })
            }
        })
    }

    const handleForm = (e, val) => {
        setStatus(e.target.value); 
        setCandidateId(val?.id);
        Swal.fire({
            title: 'Are you sure?',
            text: `You want to chnage status to ${e.target.value}!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Change!',
            cancelButtonText: 'No, Cancel!',
            confirmButtonColor: '#1F1E30', 
            cancelButtonColor: '#F44336',
            allowOutsideClick:false,
        }).then((result) => {
            if (result.isConfirmed) {
                setInterviewModal(true);
                setFormData({
                    candidate_id: val?.id,
                    candidate: val?.candidate,
                    contact_person_name: val?.Position?.Company?.poc1_name,
                    phone_code: "IN",
                    contact_person_mobile_number: val?.Position?.Company?.poc1_phone,
                    candidate_email: val?.candidate_email,
                    scheduled_date: new Date().toISOString().split("T")[0],
                    interview_round: "1",
                    interview_status: "Interview Scheduled",
                    interview_done: "In Progress",
                })
            }
        })
    }
    // updating candidate current application status
    const handleStatusSubmit = async ( ) => {
        if (status === "Interview Scheduled" && interviewModal) {
            const errorList = validateInterviewForm();
            console.log("errorList", errorList);
            if (Object.keys(errorList).length > 0) {
                setErrors(errorList);
                return;
            }
        }
        Swal.fire({
            title: 'Are you sure?',
            text: `You want to change status to ${status}!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Change!',
            cancelButtonText: 'No, Cancel!',
            confirmButtonColor: '#1F1E30', 
            cancelButtonColor: '#F44336',
            allowOutsideClick:false,
            input: 'textarea',
            inputLabel: 'Remark',
            inputPlaceholder: 'Enter remark...',
            inputAttributes: {'aria-label': 'Enter Reason',},
        }).then((result) => {
            if (result.isConfirmed) {
                const today = new Date();
                const date = today.toISOString().split("T")[0];
                // console.log("============>>>>> candiate id", candidateId, status);
                let data = {
                    candidate_status: status,
                    status_date: date,
                    remarks: result.value || "",
                    recruiter_id: localStorage.getItem("userId")
                }
                // console.log("dataATSStatus========>>>>>>>", data, candidateId);
                if (status !== "Interview Scheduled") {
                    const options = {
                        url: `${basePath}/atsstatus/${candidateId}`,
                        method: "PATCH",
                        headers: {
                           ...apiHeaderJSON,
                        },
                        data: data,
                    }
                    axios(options)
                        .then((response) => {
                            if (response.status === 200) {
                                // console.log(response);
                                getList();
                                setCandidateId(false);
                                toast.success("Candidate Status Updated Successfully");
                            }
                            else {
                                toast.error("Unable to Update");
                            }
                            setLoading(false);
                        })
                        .catch((e) => {
                            setLoading(false);
                            toast.error(e.response?.data?.message || e.response?.data?.error || "There is some network error!! Please try again later.");
                            setCandidateId(false);
                             
                        });
                }
                else if (status === "Interview Scheduled" && interviewModal) {
                    const errorList = validateInterviewForm();
                    console.log("errorList", errorList);
                    if (Object.keys(errorList).length > 0) {
                        setErrors(errorList);
                        return;
                    }
                    setLoading("4");
                    data = {
                        candidate_status: status,
                        status_date: date,
                        remarks: result.value || "",
                        recruiter_id: localStorage.getItem("userId"),
                        interview_data: formData,
                    }
                    // console.log("============>>>>> candiate id 2", candidateId, status, data);
                    const options = {
                        url: `${basePath}/atsstatus/${candidateId}`,
                        method: "PATCH",
                        headers: {
                            ...apiHeaderJSON,
                        },
                        data: data,
                    }
                    axios(options)
                        .then((response) => {
                            if (response.status === 200) {
                                // console.log(response);
                                getList();
                                setInterviewModal(false);
                                setCandidateId(false);
                                toast.success("Candidate Status Updated Successfully");
                            }
                            else {
                                toast.error("Unable to Update");
                            }
                        })
                        .catch((e) => {
                            toast.error(e.response?.data?.message || e.response?.data?.error || "There is some network error!! Please try again later.");
                            setCandidateId(false);
                             
                        });

                }
                else if (status === "Interview Scheduled" && !interviewModal) {
                    checkCandidateExist(candidateId);
                }
            }
        })
    }

     const validateInterviewForm = ()=>{
        const errors = {};
        if (!formData?.interview_date || formData?.interview_date.trim() === "") {
            errors.interview_date = "Interview Date is required!";
            return errors;
        }
        if (!formData?.interview_time || formData?.interview_time.trim() === "") {
            errors.interview_time = "Interview TIme is required!";
            return errors;
        }
        if (!formData?.interview_mode) {
            errors.interview_mode = "Interview Mode is required!";
            return errors;
        }
        if (!formData?.interview_location || formData?.interview_location.trim() === "") {
            errors.interview_location = "Interview Location is required!";
            return errors;
        }
        if (!formData?.contact_person_name || formData?.contact_person_name.trim() === "") {
            errors.contact_person_name = "Name is required!";
            return errors;
        } else if (formData?.contact_person_name && formData?.contact_person_name?.length < 3) {
            errors.contact_person_name = "Name must be at least 3 characters!";
            return errors;
        }
        // mobile number validation
        if (!formData?.phone_code && formData?.contact_person_mobile_number) {
            errors.phone_code = "Required!";
            return errors;
        }
        if (formData?.phone_code && formData?.contact_person_mobile_number) {
            const validateNum = validatePhoneNumber(formData?.phone_code, formData?.contact_person_mobile_number);
            if(!validateNum?.isValid && validateNum?.codeError) {
                errors.phone_code = validateNum?.message;
                return errors;
            }
            else if(!validateNum?.isValid && !validateNum?.codeError) {
                errors.contact_person_mobile_number = validateNum?.message;
                return errors;
            }
        }
        if (formData?.interview_remarks && formData?.interview_remarks?.length < 2) {
            errors.interview_remarks = "Remark must be at least 2 characters!";
            return errors;
        }
        
        return errors;
    }

    useEffect(()=> {
        if (isStatusChanged) {
            handleStatusSubmit();
            setIsStatusChanged(false);
        }
    },[isStatusChanged]);

    const handleStatus = (e, val)=> {
        setStatus(e.target.value); 
        setCandidateId(val?.id);
        if(e.target.value==='Interview Scheduled') {handleForm(e, val);} 
        else { setIsStatusChanged(true) }
    }

    // updating candidate personal details
    const handleCandidateSubmit = () => {
        // console.log("handleCandidateSubmit => formData =>",formData);
        const errorList = validateForm();
        console.log("errorList", errorList);
        if (Object.keys(errorList).length > 0) {
            setErrors(errorList);
            return;
        }
        Swal.fire({
            title: 'Are you sure?',
            text: "You want to save!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Save!',
            cancelButtonText: 'No, Cancel!',
            confirmButtonColor: '#1F1E30', 
            cancelButtonColor: '#F44336',
            allowOutsideClick:false,
        }).then((result) => {
            if (result.isConfirmed) {
            setLoadingUpdate(true);
            const data = {
                ...formData,
                candidate_resume: null,
                recruiter_id: localStorage.getItem("userId")
            }
            if(isObject(formData?.candidate_resume)){
                data.candidate_resume = formData?.candidate_resume;
            }
            // console.log("=========:>>>>>> ", data);
            const options = {
                headers: {...apiHeaderFile},
            }
            axios.patch(`${basePath}/editatspipeline/${viewCandidate?.id}`,data, options)
            .then((response) => {
                if (response.status === 200) {
                    // console.log(response);
                    handleClose();
                    getList();
                    setLoadingUpdate(false);
                    toast.success(response?.data?.message || "Updated Successfully");
                }
                else {
                    setLoadingUpdate(false);
                    toast.error(response?.data?.message || "Opps!! Something went wrong.");
                }
            })
            .catch((e) => {
                setLoadingUpdate(false);
                console.log(e);
                toast.error(e.response?.data?.message || "Internal server error!");
            });
        }})
    }

    const validateForm = ()=>{
        const errors = {};
        if (!formData?.candidate || formData?.candidate.trim() === "") {
            errors.candidate = "Candidate name is required!";
            return errors;
        } else if (formData?.candidate.length < 3) {
            errors.candidate = "Name must be at least 3 characters!";
            return errors;
        } else if (!/^[A-Za-z\s]+$/.test(formData?.candidate)) {
            errors.candidate = "Name can only contain letters!";
            return errors;
        }
        // Email validation
        if (!formData?.candidate_email || formData?.candidate_email.trim() === "") {
            errors.candidate_email = "Email is required!";
            return errors;
        } else if (
            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData?.candidate_email)
        ) {
            errors.candidate_email = "Invalid email address!";
            return errors;
        }

        // mobile number validation
        if (!formData?.phone_code || formData?.phone_code.trim() === "") {
            errors.phone_code = "Required!";
            return errors;
        }
        if (!formData?.candidate_phone || formData?.candidate_phone.trim() === "") {
            errors.candidate_phone = "Mobile number is required!";
        } else if (formData?.phone_code && formData?.candidate_phone) {
            const validateNum = validatePhoneNumber(formData?.phone_code, formData?.candidate_phone);
            if(!validateNum?.isValid && validateNum?.codeError) {
                errors.phone_code = validateNum?.message;
                return errors;
            }
            else if(!validateNum?.isValid && !validateNum?.codeError) {
                errors.candidate_phone = validateNum?.message;
                return errors;
            }
        }
        
        if ((!formData?.phone_alt_code || formData?.phone_alt_code.trim() === "") && formData?.candidate_alt_phone) {
            errors.phone_alt_code = "Required!";
            return errors;
        }
        // if (!formData?.candidate_alt_phone || formData?.candidate_alt_phone.trim() === "") {
        //     errors.candidate_alt_phone = "Mobile number is required!";
        // }
        if (formData?.phone_alt_code && formData?.candidate_alt_phone) {
            const validateNum = validatePhoneNumber(formData?.phone_alt_code, formData?.candidate_alt_phone);
            if(!validateNum?.isValid && validateNum?.codeError) {
                errors.phone_alt_code = validateNum?.message;
                return errors;
            } else if(!validateNum?.isValid && !validateNum?.codeError) {
                errors.candidate_alt_phone = validateNum?.message;
                return errors;
            }
        }

        if (!formData?.candidate_location || formData?.candidate_location.trim() === "") {
            errors.candidate_location = "Candidate location is required!";
            return errors;
        } else if (!/^[A-Za-z\s]+$/.test(formData?.candidate_location)) {
            errors.candidate_location = "Location can only contain letters!";
            return errors;
        }
        if (!formData?.candidate_qualification || formData?.candidate_qualification.trim() === "") {
            errors.candidate_qualification = "Qualification is required!";
            return errors;
        }
        if (!formData?.current_currency_code) {
            errors.current_currency_code = "Required!";
            return errors;
        }
        if (!formData?.candidate_current_ctc || formData?.candidate_current_ctc.trim() === "") {
            errors.candidate_current_ctc = "Current CTC is required!";
            return errors;
        } else if (!validateNumber(formData?.candidate_current_ctc, 100000000)?.success) {
            errors.candidate_current_ctc = validateNumber(formData?.candidate_current_ctc, 500)?.message;
            return errors;
        }
        if (!formData?.candidate_ectc_type) {
            errors.candidate_ectc_type = "Required!";
            return errors;
        }
        if (!formData?.expected_currency_code) {
            errors.expected_currency_code = "Required!";
            return errors;
        }
        if (!formData?.candidate_expected_ctc || formData?.candidate_expected_ctc.trim() === "") {
            errors.candidate_expected_ctc = "Expected CTC is required!";
            return errors;
        } else if (!validateNumber(formData?.candidate_expected_ctc, 100000000)?.success) {
            errors.candidate_expected_ctc = validateNumber(formData?.candidate_expected_ctc, 500)?.message;
            return errors;
        }
        if (!formData?.candidate_industry || formData?.candidate_industry.trim() === "") {
            errors.candidate_industry = "Industry is required!";
            return errors;
        }
        if (!formData?.candidate_experience || formData?.candidate_experience.trim() === "") {
            errors.candidate_experience = "Experience is required!";
            return errors;
        } else if (!validateNumber(formData?.candidate_experience, 50)?.success) {
            errors.candidate_experience = validateNumber(formData?.candidate_experience, 500)?.message;
            return errors;
        }
        if (!formData?.candidate_notice_period) {
            errors.candidate_notice_period = "This field is required!";
            return errors;
        } else if (!validateNumber(formData?.candidate_notice_period, 500)?.success) {
            errors.candidate_notice_period = validateNumber(formData?.candidate_notice_period, 500)?.message;
            return errors;
        }
        if (!formData?.candidate_gender || formData?.candidate_gender.trim() === "") {
            errors.candidate_gender = "This field is required!";
            return errors;
        }
        if (formData?.candidate_dob && !isValidDateTillCurrent(formData?.candidate_dob)) {
            errors.candidate_dob = "DOB should be less or equal to current year!";
            return errors;
        }
        if (formData?.candidate_resume && isObject(formData?.candidate_resume)){
            const valid = validateFile(formData?.candidate_resume, 5, ['application/pdf']);
            if (!valid?.valid) {
                errors.candidate_gender = valid?.message;
                return errors;
            }
        }       
            if(!validateMandatory()){
                errors.required = "Required!";
                return errors;
            }
        return errors;
    }
   
    // valiadte that is any questions answer is empty or not  
    const validateMandatory = () => {
        let isValid = true;

        const updatedQuestions = Array.isArray(formData?.position_questions) && formData?.position_questions.map(item => {
        if (item.is_mandatory === 1 && (!item.response_text || item.response_text.trim() === "")) {
            isValid = false;
            return { ...item, error_text: "This question is mandatory." };
        }
        return { ...item, error_text: "" };
        });

        setFormData(prev => ({
        ...prev,
        position_questions: updatedQuestions || [],
        }));

        return isValid;
    };

    const handleDownload = async () => {
        
        try {
            const response = await fetch(`${basePath}/downloadresume/${formData?.id}`,{
                headers:apiHeaderJSON
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${formData?.candidate.replace(/ /g, "_")}_resume_${new Date().toISOString().split("T")[0]?.split("-")[2]}-${monthData[parseInt(new Date().toISOString().split("T")[0]?.split("-")[1])]}-${new Date().toISOString().split("T")[0]?.split("-")[0]}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url); // Cleanup the URL object
        } catch (error) {
            console.error('There is a problem with the download:', error);
            if (error?.status === 404) {
                toast.error(error?.response?.error);
            }
            else {
                toast.error("There is a problem with the download");
            }
        }
    }

    const handleFilter = () => {
        setLoadingFilter("1");
        getList();
    };

    const handlePositionFilter = useCallback(() => {
        setLoadingFilter("4");
        getPositionWiseData();
    },[getPositionWiseData]);
    
    const handlePositionClear = useCallback(() => {
        setLoadingFilter("5");
        setPositionFilter({
            fromDate: "",
            toDate: "",
            company: "",
            position: "",
            orderBy: "upload_date",
            isActive: positionFilter?.isActive,
            recruiter: "",
            orderDirection: "DESC",
            status: ""
        });
        setFilterData({
            ...filterData,
            isActive: positionFilter?.isActive,
        });
        setIschanged({...ischanged, positionListChanged: true, getListChanged:false})
    },[ischanged, allUsers, positionFilter]);

    const handleLimitPositionList = (e)=> {
        setPaginationPositionList({...paginationPositionList, limit: e.target.value});
        setIschanged({...ischanged, positionListChanged: true})
    }
    const handlePrevPositionList = (e)=> {
        // console.log("paginationPositionList?.totalPages > paginationPositionList?.page",paginationPositionList?.totalPages, paginationPositionList?.page)
        if (paginationPositionList?.page > 1) {
            setPaginationPositionList({...paginationPositionList, page: paginationPositionList?.page - 1});
            setIschanged({...ischanged, positionListChanged: true})
        }
    }
    const handleNextPositionList = (e)=> {
        // console.log("paginationPositionList?.totalPages > paginationPositionList?.page",paginationPositionList?.totalPages, paginationPositionList?.page)
        if (paginationPositionList?.totalPages > paginationPositionList?.page) {
            setPaginationPositionList({...paginationPositionList, page: paginationPositionList?.page + 1});
            setIschanged({...ischanged, positionListChanged: true})
        }
    }

    const handleClear = (e)=> {
        setLoadingFilter("2");
        const url = new URL(window.location.href);
        url.searchParams.delete("status");
        url.searchParams.delete("position");
        url.searchParams.delete("company");
        url.searchParams.delete("fromDate"); 
        url.searchParams.delete("toDate"); 
        window.history.replaceState({}, document.title, url.pathname + url.search);
        setPositionFilter({
            fromDate: "", toDate: "",
            company: "", position: "",
            orderBy: "", recruiter: "",
            orderDirection: "", status: ""
        });
        setFilterData({
            fromDate: "", toDate: "",
            status: "", company: "",
            position: "", candidate: "", location: "", mobile: "", email: "", recruiter: "",
            positionStatus: "Open", orderBy: "sent_to_client_date",
            orderDirection: "DESC"
        });
        const all = allUsers?.filter((val)=>{
            if(val?.activated === 1) return val;
        });
        setUsersOption(all);
        setIschanged({...ischanged, getListChanged: true});
    }

    const handlePositionModal = ()=> {
        setLoading("3");
        getPositionWiseData(); 
        setPositionWiseView(true);
    }
    // console.log(candidate, countryPhone, countryPhoneLength);

    const handleRefresh = () => {
        // console.log("loading || loadingFilter",loading, loadingFilter)
        if (!loading || !loadingFilter) {
            setLoading("1");
            getList();
        }
    }

    const handleRefreshPosition = () => {
        setLoading("2");
        getPositionWiseData();
    }

    // candidate details form input handle function
    const handleChangeInput = useCallback((event, id)=> {
        const {name, value} = event?.target;
        console.log(name, value);
        if (name === "answer") {
        setFormData(prev => ({
            ...prev,
            position_questions: prev.position_questions.map(item =>
                item.question_id === id
                ? { ...item, response_text: value, error_text: "" }
                : item
            )
        }));
        }
        else if ( name === 'interview_mode') {
            setFormData(prev => ({
            ...prev,
            [name]: value,
            interview_location: value === 'In Person' ? atsPipeline?.find(item => item?.id === candidateId)?.Position?.Company?.address : ''
            }));
        } else if (name === "current_currency_code") {
        setFormData({ ...formData, [name]: value, expected_currency_code: value }); setErrors({...errors, [name]: "", expected_currency_code: ""});
        } else {setFormData({ ...formData, [name]: value, }); setErrors({...errors, [name]: ""});}
    },[formData, errors]);


    const handleChangeFilter = useCallback((event)=> {
        const {name, value} = event?.target;
        setFilterData({ ...filterData, [name]: value, });
    },[filterData]);

    const handleChangePositionFilter = useCallback((event)=> {
        const {name, value} = event?.target;
        setPositionFilter({ ...positionFilter, [name]: value,});
    },[positionFilter]);

    const handleCheck = useCallback((event)=> {
        //  console.log("event.target",event.target);
        const {checked } = event?.target;
        const num = !checked ? 2 : 1;
        const all = allUsers?.filter((val)=>{
            if(val?.activated === num) return val;
        });
        setFilterData({ ...filterData, isActive: checked }); 
        setUsersOption(all);
    },[allUsers, filterData]);

    const handlePositionCheck = useCallback((event)=> {
        //  console.log("event.target",event.target);
        const {checked } = event?.target;
        const num = !checked ? 2 : 1;
        const all = allUsers?.filter((val,idx)=>{
            if(val?.activated === num) return val;
        });
        setPositionFilter({ ...positionFilter, isActive: checked }); 
        // console.log("all",all);
        setUsersOption(all);
    },[allUsers]);

     // handling edit button 
    const handleEdit = (val) => {
        // console.log("edit val =>", val);
        setFormData({
            id: val?.id,
            candidate: val?.candidate || "",
            candidate_email: val?.candidate_email || "",
            phone_code: val?.phone_code || "",
            candidate_phone: val?.candidate_phone || "",
            phone_alt_code: val?.phone_alt_code || "",
            candidate_alt_phone: val?.candidate_alt_phone || "",
            candidate_location: val?.candidate_location || "",
            candidate_qualification: val?.candidate_qualification || "",
            current_currency_code: val?.current_currency_code || "",
            candidate_current_ctc: val?.candidate_current_ctc || "",
            candidate_ectc_type: val?.candidate_ectc_type || "",
            expected_currency_code: val?.expected_currency_code || "",
            candidate_expected_ctc: val?.candidate_expected_ctc || "",
            candidate_dob: val?.candidate_dob || "",
            candidate_industry: val?.candidate_industry || "",
            candidate_organization: val?.candidate_organization || "",
            candidate_designation: val?.candidate_designation || "",
            candidate_experience: val?.candidate_experience || "",
            candidate_notice_period: val?.candidate_notice_period || "",
            candidate_gender: val?.candidate_gender || "",
            candidate_resume: val?.resume_link || "",
            position_questions: val?.CandidateQnAs || [],
            candidate_remarks: val?.candidate_remarks 
        });
        setViewCandidate(val)
    }
    const handleCancelEdit = () => {
        // console.log("edit val =>", viewCandidate);
        setFormData({
            id: viewCandidate?.id,
            candidate: viewCandidate?.candidate || "",
            candidate_email: viewCandidate?.candidate_email || "",
            phone_code: viewCandidate?.phone_code || "",
            candidate_phone: viewCandidate?.candidate_phone || "",
            phone_alt_code: viewCandidate?.phone_alt_code || "",
            candidate_alt_phone: viewCandidate?.candidate_alt_phone || "",
            candidate_location: viewCandidate?.candidate_location || "",
            candidate_qualification: viewCandidate?.candidate_qualification || "",
            current_currency_code: viewCandidate?.current_currency_code || "",
            candidate_current_ctc: viewCandidate?.candidate_current_ctc || "",
            candidate_ectc_type: viewCandidate?.candidate_ectc_type || "",
            expected_currency_code: viewCandidate?.expected_currency_code || "",
            candidate_expected_ctc: viewCandidate?.candidate_expected_ctc || "",
            candidate_dob: viewCandidate?.candidate_dob || "",
            candidate_industry: viewCandidate?.candidate_industry || "",
            candidate_organization: viewCandidate?.candidate_organization || "",
            candidate_designation: viewCandidate?.candidate_designation || "",
            candidate_experience: viewCandidate?.candidate_experience || "",
            candidate_notice_period: viewCandidate?.candidate_notice_period || "",
            candidate_gender: viewCandidate?.candidate_gender || "",
            candidate_resume: viewCandidate?.candidate_resume || "",
            position_questions: viewCandidate?.CandidateQnAs || [],
            candidate_remarks: viewCandidate?.candidate_remarks 
        });
        setViewCandidate(viewCandidate);
        setCandidateEdit(false);
    }
    const handleEditOn = ()=> {
        setCandidateEdit(true);
    }
    const handleClose = ()=> {
        // console.log("onClose out");
        setPositionWiseView(false);
        setViewCandidate(false);
        setViewCompany(false);
        setCandidateEdit(false);
        setViewCandidateHistory(false);
        setInterviewModal(false);
        setFormData({});
        setErrors({});
    }

    const handleLimit = (e)=> {
        setPagination({...pagination, limit: e.target.value});
        setIschanged({...ischanged, getListChanged: true});
    }
    const handlePrev = (e)=> {
        if (pagination?.page > 1) {
            setPagination({...pagination, page: pagination?.page - 1});
            setIschanged({...ischanged, getListChanged: true});
        }
    }
    const handleNext = (e)=> {
        
        if (pagination?.totalPages > pagination?.page) {
            setPagination({...pagination, page: pagination?.page + 1});
            setIschanged({...ischanged, getListChanged: true});
        }
    }

    const handleCheckStatus = (value)=> {
        const statusList = [
        {name:"CV Rejected", className: "text-red-500 redBox"}, 
        {name:"Duplicate CV", className: "text-white rounded-lg bg-yellow-700"},
        {name:"Backout", className: "text-red-700 redBox"}, 
        {name:"Blacklist", className: "text-white bg-stone-900 rounded-lg"},
        {name:"Rejected Post Interview", className: "text-red-500 redBox"},
        {name:"Interview Scheduled", className: "rounded-lg bg-purple-200 text-purple-800"}, 
        {name:"Interview Feedback Pending", className: "rounded-lg text-amber-800 bg-amber-300"},
        {name:"Shortlisted Next Round", className: "rounded-lg text-blue-500 blueBox"}, 
        {name:"Hold Post Interview", className: "rounded-lg text-yellow-500 yellowBox"},
    ];
        return statusList.find(status => status?.name === value) || false;
    }

    return (
        <section onClick={() => { setIsModalOpen(false); }} className='lightBabyGreen baseHeightWidth customScroll mb-5'>
            {/* RefreshButton => used for refresh table data */}
            <RefreshButton onClick={handleRefresh} position='fixed' />
            {/* PageBanner => used to show page banner info */}
            <PageBanner pageName='ATS Pipeline' pageTitle='Ready to start your day' src='/img/registration.png' alt="ATS Pipeline" />
            {/* Interview Schedule Modal */}
            {interviewModal && (
                <InterviewScheduleModal
                data={formData}
                onChange={handleChangeInput}
                onCancel={handleClose}
                onClose={handleClose}
                onSubmit={handleStatusSubmit}
                loading={loading === "4"}
                errors={errors} 
                />)
            }
            {/* View and edit candidate info */}
            {viewCandidate && 
                (<EditCandidate 
                onChange={handleChangeInput}
                onCancel={handleCancelEdit}
                onClose={handleClose}
                onSubmit={handleCandidateSubmit}
                onEdit={handleEditOn}
                OnlyView={!user[index]?.edit_access}
                data={formData}
                onDownload={handleDownload}
                loading={loadingUpdate}
                errors={errors}
                disabled={!candidateEdit}
                />)
            }
            { viewCompany ? <CompanyInfo data={viewCompany} onClose={handleClose} /> : null}
            {/* View candidate status history  */}
            {viewCandidateHistory &&
                (<CandidateStatusHistory
                onClose={handleClose}
                data={viewCandidateHistory}
                />)
            }
            {positionWiseView &&
                (<PositionWiseData
                rows={positionWiseData}
                onRefresh={handleRefreshPosition}
                onClose={handleClose}
                filter={positionFilter}
                loading={loading === "3"}
                loadingFilter={loadingFilter === "4"}
                loadingClear={loadingFilter === "5"}
                onChangeFilter={handleChangePositionFilter}
                onFilter={handlePositionFilter}
                onFilterClear={handlePositionClear}
                usersOption={usersOption}
                onPositionCheck={handlePositionCheck}
                onPositionSelect={handlePositionSelect}
                pagination={paginationPositionList}
                onSort={handleSort}
                onLimit={handleLimitPositionList}
                onPrev={handlePrevPositionList}
                onNext={handleNextPositionList}
                />)
            }
            {/* Filter */}
            <div className=' grid lg:grid-cols-6 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 items-center gap-3 grayBlurShadow bg-white p-3 mt-5 rounded-xl'>
                {/* <h1>Date Filter</h1> */}
                <InputField  id="fromDate" name="fromDate" type="date" label="From:"
                value={filterData?.fromDate}
                onChange={handleChangeFilter}
                />
                <InputField  id="toDate" name="toDate" type="date" label="To:"
                value={filterData?.toDate}
                onChange={handleChangeFilter}
                />
                <InputField  id="candidate" name="candidate" type="text" label="Candidate:"
                placeholder="Enter Candidate"
                value={filterData?.candidate}
                onChange={handleChangeFilter}
                />
                <InputField  id="company" name="company" type="text" label="Company:"
                placeholder="Enter Company"
                value={filterData?.company}
                onChange={handleChangeFilter}
                />
                <InputField  id="position" name="position" type="text" label="Position:"
                placeholder="Enter Position"
                value={filterData?.position}
                onChange={handleChangeFilter}
                />
                <InputField  id="location" name="location" type="text" label="Location:"
                placeholder="Enter Location"
                value={filterData?.location}
                onChange={handleChangeFilter}
                />
                {localStorage.getItem("role") === "Recruiter" ? null : 
                    (<Dropdown  id="recruiter"  name="recruiter"  label="Recruiter:"
                        onChange={handleChangeFilter}
                        className=" rounded border border-gray-300 w-full text-[0.8rem]"
                        placeholder={`Select Recruiter`}
                        value={filterData?.recruiter}
                        options={usersOption}
                        search={true} // to enable search input
                        checkBox={true} // to enable checkbox
                        checkValue={filterData?.isActive} // to make checkbox check and uncheck
                        onCheck={handleCheck} // to make changes in list of options onChange
                    />)
                }
                <Dropdown id="status" name="status" label="Sourcing Status:"
                    onChange={handleChangeFilter}
                    className=" rounded border border-gray-300 w-full text-[0.8rem]"
                    placeholder={`All`}
                    value={filterData?.status}
                    options={candidateStatusList}
                />
                <Dropdown id="positionStatus" name="positionStatus" label="Position Status:"
                    onChange={handleChangeFilter}
                    className=" rounded border border-gray-300 w-full text-[0.8rem]"
                    placeholder={`All`}
                    value={filterData?.positionStatus}
                    options={positionStatusOptions}
                />
                <div className="flex gap-3 col-span-1">
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Apply Filter</label>
                        <BasicButton onClick={handleFilter} buttonName='Apply Filter' className='darkPurple text-nowrap' shadow={true}
                        disabled={loading || loadingFilter || (!filterData?.fromDate && !filterData?.toDate && !filterData?.candidate && !filterData?.company && !filterData?.position && !filterData?.recruiter && !filterData?.status && !filterData?.positionStatus)} 
                        loading={loadingFilter === "1"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
                    </div>
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Clear Filter</label>
                        <BasicButton onClick={handleClear} buttonName='Clear Filter' className="bg-red-600 text-nowrap" shadow={true}
                        disabled={loading || loadingFilter || (!filterData?.fromDate && !filterData?.toDate && !filterData?.candidate && !filterData?.company && !filterData?.position && !filterData?.recruiter && !filterData?.status && !filterData?.positionStatus)} 
                        loading={loadingFilter === "2"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-red-900" />
                    </div>
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Excel Export</label>
                        <BasicButton onClick={handleExport} buttonName='Excel' className="bg-green-800 text-nowrap" shadow={true}
                        disabled={loading || loadingFilter || atsPipeline?.length === 0 } 
                        loading={loadingFilter === "3"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-green-950" />
                    </div>
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Position Details</label>
                        <BasicButton onClick={handlePositionModal} buttonName='Position Details' className="bg-purple-700 text-nowrap" shadow={true}
                        disabled={loading}
                        rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-purple-900" />
                    </div>
                </div>
            </div>
            {loading === "1" ?
                <Loader/> :
                Array.isArray(atsPipeline) && atsPipeline?.length >= 1 ?
                <section className='tableWrapper'>
                    <div className='tableBody'>
                        <table className='w-full table-fixed border-collapse'>
                            <thead className='tableHead'>
                                <tr className=' text-left'>
                                    <th className='whitespace-nowrap text-center w-[5%]'>Sr. No.</th>
                                    <th className='cursor-pointer w-48'>
                                        <div className='flex item-center gap-2 justify-start' onClick={() => handleAtsSort("sent_to_client_date")}>
                                            Sent Date
                                            {
                                                filterData?.orderBy === "sent_to_client_date" && filterData?.orderDirection === "ASC" ?
                                                <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> :
                                                filterData?.orderBy === "sent_to_client_date" && filterData?.orderDirection === "DESC" ?
                                                <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
                                                <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />                                                         
                                            }
                                        </div>
                                    </th>
                                    <th  className=' whitespace-nowrap text-center w-52'>Current Status</th>
                                    <th className=' whitespace-nowrap ' >
                                        <div onClick={() => handleAtsSort("candidate")} className='flex item-center gap-2 justify-start w-full cursor-pointer'>
                                            Candidate
                                            {filterData?.orderBy === "candidate" && filterData?.orderDirection === "ASC" ?
                                                <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> :
                                                filterData?.orderBy === "candidate" && filterData?.orderDirection === "DESC" ?
                                                    <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
                                                    <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />}
                                        </div></th>
                                    <th className=' whitespace-nowrap' >
                                       
                                        <div onClick={() => handleAtsSort("position")} className='flex item-center gap-2 justify-start w-full cursor-pointer'>
                                            Position
                                            {filterData?.orderBy === "position" && filterData?.orderDirection === "ASC" ?
                                                <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> :
                                                filterData?.orderBy === "candidate" && filterData?.orderDirection === "DESC" ?
                                                <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
                                                <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />}
                                        </div>
                                    </th>
                                    <th className=' text-center w-32'>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    Array.isArray(atsPipeline) && atsPipeline?.map((val, idx) => {
                                        return (
                                            <tr key={val?.id} id={val?.id} className='font-semibold text-sm text-left'>
                                                <td className='whitespace-nowrap text-center'>{idx + 1}</td>
                                                <td>
                                                    <span className='line-clamp-1 text-ellipsis'>{val?.sent_to_client_date ? formatDate(val?.sent_to_client_date) : "--"}</span>
                                                    {localStorage.getItem("role") === "Recruiter" || localStorage.getItem("role") === "Team Lead" ? null : 
                                                    (<span className='line-clamp-1 text-ellipsis text-green-600'>{val?.User?.name}</span>)}
                                                    </td>
                                                <td>
                                                    {
                                                        handleCheckStatus(val?.candidate_status) ?
                                                        <h3 className={`line-clamp-1 text-ellipsis w-full text-center text-nowrap outline-none border border-gray-300 py-2.5 px-1 ${handleCheckStatus(val?.candidate_status)?.className}`}>
                                                            {handleCheckStatus(val?.candidate_status)?.name}
                                                        </h3> :
                                                        val?.candidate_status === "Sent To Client" ?
                                                            <Dropdown  id="candidate_status"  name="candidate_status" 
                                                                onChange={(e) => { if (user[index]?.edit_access) handleStatus(e,val); }}
                                                                className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                                                placeholder={`Select Status`}
                                                                value={val?.candidate_status}
                                                                disabled={!user[index]?.edit_access}
                                                                options={atsStatus1}
                                                            /> :
                                                        val?.candidate_status === "CV On Hold" ?
                                                            <Dropdown  id="candidate_status"  name="candidate_status" 
                                                                onChange={(e) => { if (user[index]?.edit_access) handleStatus(e,val); }}
                                                                className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                                                placeholder={`Select Status`}
                                                                value={val?.candidate_status}
                                                                disabled={!user[index]?.edit_access}
                                                                options={atsStatus5}
                                                            /> :    
                                                        val?.candidate_status === "Shortlisted" ?
                                                            <Dropdown  id="candidate_status"  name="candidate_status" 
                                                                onChange={(e) => { if (user[index]?.edit_access) handleStatus(e,val); }}
                                                                className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                                                placeholder={`Select Status`}
                                                                value={val?.candidate_status}
                                                                disabled={!user[index]?.edit_access}
                                                                options={atsStatus2}
                                                            /> :
                                                        val?.candidate_status === "Final Selection" ?
                                                            <Dropdown  id="candidate_status"  name="candidate_status" 
                                                                onChange={(e) => { if (user[index]?.edit_access) handleStatus(e,val); }}
                                                                className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                                                placeholder={`Select Status`}
                                                                value={val?.candidate_status}
                                                                disabled={!user[index]?.edit_access}
                                                                options={atsStatus3}
                                                            /> :
                                                        val?.candidate_status === "Final Joining" ?
                                                            <Dropdown  id="candidate_status"  name="candidate_status" 
                                                                onChange={(e) => { if (user[index]?.edit_access) handleStatus(e,val); }}
                                                                className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                                                placeholder={`Select Status`}
                                                                value={val?.candidate_status}
                                                                disabled={!user[index]?.edit_access}
                                                                options={atsStatus4}
                                                            /> :
                                                        <div className={` p-2 rounded border border-gray-300 w-full text-[0.8rem] `}>
                                                            <h3 className={` whitespace-nowrap w-full text-center outline-none py-2 px-1 rounded-lg text-yellow-500 yellowBox`}>
                                                                {val?.candidate_status}
                                                            </h3>
                                                        </div>
                                                    }
                                                </td>
                                                <td className=' whitespace-nowrap'>
                                                    <span className={`line-clamp-1 text-ellipsis text-blue-900 ${val?.candidate && (user[index]?.view_access || user[index]?.edit_access) && "hover:text-blue-700 hover:underline transition-all duration-150 ease-in-out cursor-pointer"}`} onClick={()=> {if (user[index]?.view_access || user[index]?.edit_access) handleEdit(val)}}>{val?.candidate || "--"}</span>
                                                    <span className='text-sm line-clamp-1 text-ellipsis text-gray-400'>{val?.candidate_email ? val?.candidate_email : "NA"}</span>
                                                </td>
                                                <td className=' whitespace-nowrap'>
                                                    <span className='line-clamp-1 text-ellipsis' >{val?.Position?.Company.company_name}</span>
                                                    <span className='text-sm line-clamp-1 text-ellipsis text-gray-400'>{val?.Position?.position}</span>
                                                </td>
                                                <td>
                                                    <div className='flex justify-center items-center gap-2'>
                                                        {localStorage.getItem("role") === "Recruiter" ? null : 
                                                        <RevertStatusButton data={val} onClick={()=> handleRevertStatus(val)} tooltipName="Revert Status" disabled={!user[index]?.edit_access} />}
                                                        <HistoryButton data={val} onClick={getCandidateHistory} tooltipName="Status History" disabled={!user[index]?.view_access} />
                                                        <EmailSendButton data={val} onClick={handleSendEmail} tooltipName="Send Email" position="bottom-left" disabled={!user[index]?.edit_access} />
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                    <Pagination onLimitChange={handleLimit} onPrevChange={handlePrev} onNextChange={handleNext}
                    limit={pagination?.pagelimit} totalRecords={pagination?.totalRecords} allPages={pagination?.totalPages} page={pagination?.page}
                    disabledPrev={pagination?.page === 1} disabledNext={pagination?.page === pagination?.totalPages}
                    />
                </section> :
                <NoRecords/>
            }

        </section>
    )
}

export default AtsPipeline;